const presentsRoute = {
	name: 'award',
	path: 'award',
	component: () => import('@/pages/configuration/page-config-presents'),
	meta: {
		title: 'Lista de regalos',
	},
	children: [
		{
			name: 'new-present',
			path: 'new',
			meta: {
				title: 'Nuevo Regalo',
			},
			components: {
				newPresentForm: () => import('@/components/configuration/presents/new-present-form'),
			},
			children: [
				{
					name: 'present-icons',
					path: 'icons/:type',
					meta: {
						title: 'Selecciona ícono',
					},
					components: {
						selectingIcon: () => import('@/components/shared/icons/icon-modal'),
					},
				},
			],
		},
	],
};

export default presentsRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/presents/index.js